export const JDLogo = 'https://huibo-data.cdn.bcebos.com/upload/04e5eac62336a023507328c94cd76c23.png';
export const kuaishouLogo = 'https://huibo-data.cdn.bcebos.com/upload/3411b97a29656d98b0541dd9048fb3a6.png';
export const meituanLogo = 'https://huibo-data.cdn.bcebos.com/upload/4c2cc00ed5861beb1fb7423a878cef80.png';

export const logoMap = {
    2: kuaishouLogo,
    3: meituanLogo,
    5: JDLogo
};

export const platformNameMap = {
    2: '快手',
    3: '美团',
    5: '京东'
};

export const platformTypeMap = {
    2: 'kuaishou',
    3: 'meituan',
    5: 'jd'
};